namespace Ir.Components.ReportDesigner.ComparisonFilterItem {

    interface IViewModel {
        colorParams: Ir.Components.General.ColorPicker.IColorPickerParams;
        nameParams: Ir.Components.General.TextBox.ITextBoxParams;
        variablesTooltipParams: Ir.Components.ReportDesigner.VariablesTooltip.IVariablesTooltipParams;
        filterSettingParams: Ir.Components.Workbook.Settings.Items.ComparisonFilterSetting.IComparisonFilterSettingParams;
        fieldSettingParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        removeButtonConfig: DevExpress.ui.dxButton.Properties;
        settingsButtonConfig: DevExpress.ui.dxButton.Properties;
        compareTooltip: string;
        compareWithVisible: KnockoutComputed<boolean>;
        compareWithSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        variablesLegendVisible: KnockoutObservable<boolean>;
        dateFieldVisible: KnockoutComputed<boolean>;

        typeLabelVisible: KnockoutObservable<boolean>;
    }

    interface IParams {
        comparisonFilter: ComparisonFilter;
        comparisonFilters: KnockoutObservableArray<ComparisonFilter>;
        metricArray: KnockoutObservable<KnockoutObservableArray<MetricField>>;
        onRemove(comparisonFilter: ComparisonFilter);
        typeLabelVisible: boolean;
        isReportTemplate: boolean;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        let comparisonFilter = params.comparisonFilter;
        self.variablesLegendVisible = ko.observable(false);
        self.typeLabelVisible = ko.observable(params.typeLabelVisible);

        self.colorParams = {
            color: comparisonFilter.color,
        };
        let nameElement = ko.observable();
        let replaceMetricName = function (newValue, oldValue) {
            if (oldValue) {
                var metricArray = params.metricArray();
                metricArray().filter(x => x.isMetric && (x as MetricField).metricContainer.comparisonType !== ComparisonMetricType.None && (x as MetricField).metricContainer.comparisonFilterId == comparisonFilter.id()).forEach(function (field) {
                    field.displayNameForDesigner(field.displayNameForDesigner().replace(`${oldValue}`, `${newValue}`));
                });
            }
        };

        self.nameParams = {
            text: comparisonFilter.name,
            width: "calc(100% - 3px)",
            onFocusIn(e) {
                self.variablesLegendVisible(true);
            },
            onFocusOut(e) {
                self.variablesLegendVisible(false);
            },
            onInitialized(e) {
                nameElement(e.element);
            },
            onValueChanged(e) {
                if (!e.value) {
                    //DISABLED UNTIL WE UNDERSTAND WHY
                    // comparisonFilter.name(e.previousValue.substr(0, 1));
                    // replaceMetricName(e.previousValue.substr(0, 1), e.previousValue);
                    
                    comparisonFilter.name(e.previousValue);
                    return;
                }
                replaceMetricName(e.value, e.previousValue);
            },
        };
        self.variablesTooltipParams = {
            target: nameElement as any,
            visible: self.variablesLegendVisible as any,
        };
        self.filterSettingParams = {
            comparisonFilter,
            isReportDesigner: true,
            label: "Type",
            labelInside: true,
            onComparisonDateOptionChanged(e) {
                if (e.value === ComparisonDateOptionEnum.Manual) {
                    comparisonFilter.dateField(null);
                }
            },
            filterComparisonDateList(dateOption: ComparisonDateOptionEnum) {
                if (params.isReportTemplate)
                    return dateOption !== ComparisonDateOptionEnum.Manual;

                return true;
            }
        };

        self.dateFieldVisible = ko.computed(function() {
            return comparisonFilter.dateOption() === ComparisonDateOptionEnum.Previous || 
                comparisonFilter.dateOption() === ComparisonDateOptionEnum.Predefined && comparisonFilter.dateRange() !== irGlobal.customDate.custom;
        });

        self.fieldSettingParams = {
            id: comparisonFilter.dateField,
            type: MappingPopoverTypeEnum.DateNonDerivedDates,
            label: "Date Field",
            tooltip: "When the Field is not informed, the comparison is made with the first date filter. Otherwise, the comparison is made with the filter with the same field.",
            disabled: ko.observable(params.isReportTemplate)
        };

        self.removeButtonConfig = {
            stylingMode: 'contained',
            icon: "remove",
            hint: "Remove the comparison filter",
            height: 25,
            width: 25,
            //width: ko.computed(() => {
            //    return comparisonFilter.filters().length > 0 ? 20 : 25;
            //}) as any,
            onClick(e) {
                params.onRemove(comparisonFilter);
            }
        };
        self.settingsButtonConfig = {
            stylingMode: 'contained',
            icon: "filter",
            text: ko.computed(() => {
                return comparisonFilter.filters().length > 0 ? comparisonFilter.filters().length : "";
            }) as any,
            hint: "Filters",
            height: 25,
            width: ko.computed(() => {
                return comparisonFilter.filters().length > 0 ? 30 : 25;
            }) as any,
            elementAttr: {
                class: ko.computed(() => {
                    return comparisonFilter.filters().length > 0 ? "button-hasfilters" : "";
                }) as any
            },
            disabled: params.isReportTemplate,
            onClick(e) {
                Ir.Components.ReportDesigner.ReportDesigner.hidePopovers();
                Ir.Components.ReportDesigner.ComparisonFilterFilters.show(comparisonFilter, e.element);
            },
        } as any;
        self.compareTooltip = "Select another comparison filter to compare. Variation values and percentage will consider it.";
        self.compareWithVisible = ko.computed(function() {
            return params.comparisonFilters().length > 1;
        });
        self.compareWithSelectBoxConfig = {
            items: ko.computed(function (this: KnockoutObservableArray<ComparisonFilter>) {
                let comparisonFilters = this().filter(x => x !== comparisonFilter);
                return comparisonFilters;
            }, params.comparisonFilters) as any,
            displayExpr: "name",
            valueExpr: "id",
            value: comparisonFilter.comparisonFilterIdBase,
            hint: self.compareTooltip,            
        };
    }
}